
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search, Filter } from "lucide-react";

interface ReisaanbiederFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  selectedProvider: string;
  setSelectedProvider: (value: string) => void;
  priceFilter: string;
  setPriceFilter: (value: string) => void;
  providers: string[];
}

export const ReisaanbiederFilters = ({
  searchTerm,
  setSearchTerm,
  selectedProvider,
  setSelectedProvider,
  priceFilter,
  setPriceFilter,
  providers
}: ReisaanbiederFiltersProps) => {
  return (
    <div className="bg-white/80 backdrop-blur-sm p-6 rounded-xl shadow-lg border border-blue-100 space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="h-5 w-5 text-blue-600" />
        <span className="font-semibold text-gray-800">Filters:</span>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="relative">
          <Search className="absolute left-3 top-3 h-4 w-4 text-gray-400" />
          <Input
            placeholder="Zoek op naam of locatie..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 border-blue-200 focus:border-blue-400"
          />
        </div>
        
        <Select value={selectedProvider} onValueChange={setSelectedProvider}>
          <SelectTrigger className="border-blue-200 focus:border-blue-400">
            <SelectValue placeholder="Selecteer reisaanbieder" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alle reisaanbieders</SelectItem>
            {providers.map((provider) => (
              <SelectItem key={provider} value={provider}>
                {provider}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        
        <Select value={priceFilter} onValueChange={setPriceFilter}>
          <SelectTrigger className="border-blue-200 focus:border-blue-400">
            <SelectValue placeholder="Prijsklasse" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Alle prijzen</SelectItem>
            <SelectItem value="500">Tot €500</SelectItem>
            <SelectItem value="1000">€500 - €1000</SelectItem>
            <SelectItem value="2000">€1000 - €2000</SelectItem>
            <SelectItem value="3500">€2000 - €3500</SelectItem>
            <SelectItem value="5000">€3500 - €5000</SelectItem>
            <SelectItem value="5000+">Vanaf €5000</SelectItem>
            <SelectItem value="onbekend">Prijs onbekend</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
